<script setup>
import { ref } from "vue";
import { store } from '../../store.js';

defineEmits(['close-modal']);

const props = defineProps({
    showCloseModalButton: {
        type: Boolean,
        default: false,
    },
    survey: {
        type: Object,
        default: () => {
            return {}
        },
    },
});

const survey = ref(props.survey);

function toggleSubmitted() {
    survey.value.isSubmitted = true;
}

</script>

<template>
    <div class="flex justify-between">
        <button v-if="props.showCloseModalButton" type="button"
            class="text-gray-500 bg-white hover:bg-gray-100 focus:outline-none  rounded-lg border border-slate-300 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 "
            @click="$emit('close-modal')">
            {{ store.translations.close_label }}
        </button>
        <button v-if="store.regions.present() && survey.isSubmitted === false" type="button"
            class="text-white bg-wageindicator-orange hover:bg-wageindicator-orange-darken focus:outline-none  font-medium rounded-lg text-sm px-5 py-2.5 text-center"
            @click="toggleSubmitted()">
            {{ store.translations.save_label }}
        </button>
    </div>
</template>
